import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Action = styled.div`
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 12px;
    cursor: pointer;
    transition: all 0.3s;
    user-select: none;

    &:hover {
        background: rgba(0, 0, 0, 0.025);
    }

    &:global(.opened) {
        background: rgba(0, 0, 0, 0.025);
    }
`;
